// nuxt不支持差异化引入
import languages from "./index.messages.national";
export default languages;
